export default "__VITE_ASSET__DTiqMKjO__"